/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {State} from "ui/feature/root/FormReducer";
import {
    StaffSelectWorkspace_piece$data
} from "ui/feature/root/staff-select/__generated__/StaffSelectWorkspace_piece.graphql";

export default function UsePollStaffSelectSteps(state: State, data: StaffSelectWorkspace_piece$data | null, retry: (() => void) | null) {

    const [shouldPoll, setShouldPoll] = React.useState<boolean>(true)

    React.useEffect(() => {
        if (!data) {
            setShouldPoll(true);
            return;
        }
        const sheets = data.sheets;
        if (sheets) {
            for (const sheet of sheets) {
                if (!sheet.bar_finder_steps) {
                    console.log("no no combine steps", sheet);
                    setShouldPoll(true);
                    return;
                }
                const step = sheet.bar_finder_steps[0];
                if (step.status !== "SUCCESS") {
                    setShouldPoll(true)
                    return;
                }
            }
            setShouldPoll(false)
        } else {
            setShouldPoll(true);
        }
    }, [data])

    React.useEffect(() => {
        if (!state.pieceId || !shouldPoll) {
            return;
        }
        const interval = setInterval(() => {
            if (retry) {
                console.log("retrying");
                retry();
            }
        }, 5000);

        return () => {
            console.log("unsubscribing the user")
            clearInterval(interval)
        }

    }, [state.pieceId, shouldPoll, setShouldPoll, retry]);
}
